<article class="demanda-uso-insumos"  ng-repeat="demanda in data track by $index">
  <header>
    <h3>Demanda de uso de insumos</h3>
    <p>{{demanda.propriedade.descricao}}</p>
    <p>Período: {{params.startDate | date:'shortDate'}} até {{params.endDate | date:'shortDate'}}</p>
    <small>Relatório gerado em {{params.atual | date:'short'}}</small>
  </header>

  <table class="table table-responsive">
    <thead>
      <tr>
        <th class="f-size-12">Produto</th>
        <th class="text-right f-size-12">Quantidade Recomendada</th>
        <th class="text-right f-size-12">Saldo Físico</th>
        <th class="text-right f-size-12">Saldo Em Uso</th>
        <th class="text-right f-size-12">Saldo</th>
        <th class="text-right f-size-12">Quantidade Receber</th>
      </tr>
    </thead>

    <tbody>
      <tr ng-repeat="produto in demanda.insumos track by $index">
        <td title="Código do Produto: {{produto.codigo}}" class="f-size-12">{{produto.descricao}}</td>
        <td class="text-right f-size-12 nowrap">
          {{produto.total | number:4}} {{produto.unidade.abreviatura}}
        </td>
        <td class="text-right f-size-12 nowrap">
          {{produto.estoque.saldo_fisico | number:4}} {{produto.estoque.unidade.abreviatura}}
        </td>
        <td class="text-right f-size-12 nowrap">
          {{produto.estoque.saldo_em_uso | number:4}} {{produto.estoque.unidade.abreviatura}}
        </td>
        <td class="text-right f-size-12 nowrap">
          {{produto.saldo | number:4}} {{produto.estoque.unidade.abreviatura}}
        </td>
        <td class="text-right f-size-12 nowrap">
          {{produto.estoque.saldo_receber | number:4}} {{produto.estoque.unidade.abreviatura}}
        </td>
      </tr>
    </tbody>
  </table>
</article>
